/**
 * Cookies left from before Core moved to a name of its own (D-217, D-247). Then the panel and Core
 * shared one origin and Core set `XSRF-TOKEN` and the session for the panel's name alone; now it
 * sets them for the pair (`.crm.example.com`). A device used before keeps both for up to two
 * weeks, and the panel, reading the first `XSRF-TOKEN`, sends the old one: every write refused
 * (419) while reads work, and signing in again changes nothing.
 *
 * With Core elsewhere, the cookies of the panel's own name alone are those leftovers: removed
 * (a cookie set without a domain is removed without one; the pair's are left as they are).
 */
export const STALE = ['XSRF-TOKEN', 'addcrm-session']

/** Whether Core answers at another name than the page's: only then are those cookies leftovers. */
export function coreElsewhere(apiUrl, origin) {
  if (!apiUrl) return false
  try {
    return new URL(apiUrl).host !== new URL(origin).host
  } catch {
    return false
  }
}

export function dropStaleCookies(apiUrl, doc = typeof document === 'undefined' ? null : document) {
  if (!doc || !coreElsewhere(apiUrl, doc.location?.origin || '')) return 0
  let dropped = 0
  for (const name of STALE) {
    if (!doc.cookie.split('; ').some((c) => c.startsWith(`${name}=`))) continue
    doc.cookie = `${name}=; Max-Age=0; path=/`
    dropped++
  }
  return dropped
}
